import React, { useState } from 'react';

const ProblemsSection = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const problems = [
    {
      icon: '/images/icons/ads.webp',
      title: 'РЕКЛАМА НЕ ОКУПАЕТСЯ',
      text: 'Льёте бюджет в рекламу, а заказов нет. ДРР растёт, прибыль падает, и непонятно что делать дальше.',
      rotate: -8,
    },
    {
      icon: '/images/icons/conversion.webp',
      title: 'КАРТОЧКИ НЕ ПРОДАЮТ',
      text: 'Низкая конверсия, мало кликов, товар теряется среди конкурентов. Карточки не цепляют покупателя.',
      rotate: 6,
    },
    {
      icon: '/images/icons/analytics.webp',
      title: 'ФИНАНСОВЫЙ ХАОС',
      text: 'Не понимаете сколько реально зарабатываете. Юнит-экономика не сходится, цифры не бьются.',
      rotate: -5,
    },
    {
      icon: '/images/icons/roi.webp',
      title: 'ВЛОЖЕНИЯ НЕ ВОЗВРАЩАЮТСЯ',
      text: 'Инвестируете в товар, рекламу, контент — а на выходе ноль.',
      rotate: 7,
    },
    {
      icon: '/images/icons/audience.webp',
      title: 'КОМАНДА БЕЗ РЕЗУЛЬТАТА',
      text: 'Подрядчики или сотрудники что-то делают, но что именно и зачем — непонятно. Нет прозрачности.',
      rotate: -6,
    },
    {
      icon: '/images/icons/wallet.webp',
      title: 'КАССОВЫЕ РАЗРЫВЫ',
      text: 'Постоянно не хватает денег на закупку. Товар заканчивается, продажи встают, цикл повторяется.',
      rotate: 5,
    },
  ];

  return (
    <section
      id="problems"
      style={{
        background: '#FFFFFF',
        padding: '45px 0 25px',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Декоративные иконки на фоне */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          pointerEvents: 'none',
          zIndex: 0,
        }}
      >
        <img
                loading="lazy"
          src="/images/icons/analytics.webp"
          alt=""
          style={{
            position: 'absolute',
            width: '100px',
            height: '100px',
            top: '8%',
            left: '4%',
            transform: 'rotate(-12deg)',
            opacity: 0.05,
            filter: 'blur(1px) grayscale(0.3)',
            animation: 'floatProblems1 6s ease-in-out infinite',
          }}
        />
        <img
                loading="lazy"
          src="/images/icons/wallet.webp"
          alt=""
          style={{
            position: 'absolute',
            width: '100px',
            height: '100px',
            top: '5%',
            right: '5%',
            transform: 'rotate(10deg)',
            opacity: 0.05,
            filter: 'blur(1px) grayscale(0.3)',
            animation: 'floatProblems2 7s ease-in-out infinite',
          }}
        />
        <img
                loading="lazy"
          src="/images/icons/audience.webp"
          alt=""
          style={{
            position: 'absolute',
            width: '100px',
            height: '100px',
            bottom: '10%',
            left: '5%',
            transform: 'rotate(8deg)',
            opacity: 0.05,
            filter: 'blur(1px) grayscale(0.3)',
            animation: 'floatProblems3 5.5s ease-in-out infinite',
          }}
        />
        <img
                loading="lazy"
          src="/images/icons/roi.webp"
          alt=""
          style={{
            position: 'absolute',
            width: '100px',
            height: '100px',
            bottom: '12%',
            right: '4%',
            transform: 'rotate(-8deg)',
            opacity: 0.05,
            filter: 'blur(1px) grayscale(0.3)',
            animation: 'floatProblems4 6.5s ease-in-out infinite',
          }}
        />
      </div>

      <div
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 24px',
          position: 'relative',
          zIndex: 1,
        }}
      >
        {/* Заголовок */}
        <div
          className="problems-header"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '24px',
            marginBottom: '10px',
          }}
        >
          <span
            style={{
              background: 'rgba(15, 15, 26, 0.08)',
              color: '#0F0F1A',
              fontSize: '14px',
              fontWeight: 500,
              padding: '12px 24px',
              borderRadius: '50px',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
            }}
          >
            ПРОБЛЕМЫ
          </span>

          <h2
            style={{
              fontSize: '42px',
              fontWeight: 800,
              color: '#0F0F1A',
              textTransform: 'uppercase',
              margin: 0,
            }}
            className="problems-title"
          >
            ЗНАКОМО?
          </h2>
        </div>

        {/* Карточки */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '0px 24px',
          }}
          className="problems-grid"
        >
          {problems.map((problem, index) => (
            <div
              key={index}
              className="problems-card-wrap"
              style={{
                position: 'relative',
                paddingTop: '70px',
              }}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              {/* Парящая иконка с подсветкой */}
              <div
                className="problems-icon-wrap"
                style={{
                  position: 'absolute',
                  top: '70px',
                  left: index % 3 === 0 ? '50px' : (index % 3 === 2 ? 'auto' : '50%'),
                  right: index % 3 === 2 ? '50px' : 'auto',
                  transform: index % 3 === 1 ? 'translate(-50%, -50%)' : 'translate(0, -50%)',
                  zIndex: 2,
                }}
              >
                {/* Glow эффект */}
                <div
                  style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '182px',
                    height: '182px',
                    background: 'radial-gradient(circle, rgba(249, 115, 22, 0.3) 0%, rgba(236, 72, 153, 0.2) 40%, transparent 70%)',
                    filter: 'blur(20px)',
                    zIndex: -1,
                    pointerEvents: 'none',
                  }}
                />

                {/* Иконка */}
                <img
                loading="lazy"
                  src={problem.icon}
                  alt=""
                  style={{
                    width: '130px',
                    height: '130px',
                    objectFit: 'contain',
                    position: 'relative',
                    zIndex: 1,
                    transform: hoveredIndex === index ? 'rotate(0deg) scale(1.1)' : `rotate(${problem.rotate}deg)`,
                    transition: 'transform 0.3s ease',
                  }}
                />
              </div>

              {/* Карточка */}
              <div
                className="problems-card"
                style={{
                  background: '#F8F9FA',
                  border: '1px solid rgba(15, 15, 26, 0.06)',
                  borderRadius: '24px',
                  padding: '80px 32px 32px',
                  transition: 'all 0.3s ease',
                  textAlign: 'left',
                  position: 'relative',
                  transform: hoveredIndex === index ? 'translateY(-4px)' : 'translateY(0)',
                  boxShadow: hoveredIndex === index
                    ? '0 20px 40px rgba(139, 92, 246, 0.15), 0 0 60px rgba(236, 72, 153, 0.1)'
                    : '0 4px 24px rgba(15, 15, 26, 0.04)',
                  borderColor: hoveredIndex === index ? 'rgba(139, 92, 246, 0.2)' : 'rgba(15, 15, 26, 0.06)',
                }}
              >
                <h3
                  style={{
                    fontSize: '20px',
                    fontWeight: 700,
                    color: '#0F0F1A',
                    textTransform: 'uppercase',
                    lineHeight: 1.3,
                    margin: '0 0 12px 0',
                  }}
                >
                  {problem.title}
                </h3>
                <p
                  style={{
                    fontSize: '15px',
                    fontWeight: 400,
                    color: 'rgba(15, 15, 26, 0.6)',
                    lineHeight: 1.6,
                    margin: 0,
                  }}
                >
                  {problem.text}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Анимации */}
      <style>
        {`
          @media (max-width: 768px) {
            .problems-grid { grid-template-columns: repeat(2, 1fr) !important; gap: 0px 16px !important; }
            .problems-header { flex-direction: column !important; align-items: flex-start !important; gap: 12px !important; }
            .problems-title { font-size: 28px !important; }
            .problems-icon-wrap { display: none !important; }
            .problems-bg-icon { display: none !important; }
            .problems-card-wrap { padding-top: 20px !important; }
            .problems-card { padding: 24px !important; min-height: auto !important; }
            .problems-card h3 { font-size: 16px !important; }
            .problems-card p { font-size: 13px !important; }
          }
          @media (max-width: 480px) {
            .problems-grid { grid-template-columns: 1fr !important; }
            .problems-title { font-size: 24px !important; }
          }

          @keyframes floatProblems1 {
            0%, 100% { transform: translate(0, 0) rotate(-12deg); }
            50% { transform: translate(-10px, -12px) rotate(-12deg); }
          }

          @keyframes floatProblems2 {
            0%, 100% { transform: translate(0, 0) rotate(10deg); }
            50% { transform: translate(10px, -14px) rotate(10deg); }
          }

          @keyframes floatProblems3 {
            0%, 100% { transform: translate(0, 0) rotate(8deg); }
            50% { transform: translate(-12px, -10px) rotate(8deg); }
          }

          @keyframes floatProblems4 {
            0%, 100% { transform: translate(0, 0) rotate(-8deg); }
            50% { transform: translate(14px, -12px) rotate(-8deg); }
          }
        `}
      </style>
    </section>
  );
};

export default ProblemsSection;
